import { render, staticRenderFns } from "./SmartTipsCustomer.vue?vue&type=template&id=69e8fb5a"
import script from "./SmartTipsCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./SmartTipsCustomer.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports